import React from "react";
import MachinesView from "./views/MachinesView.jsx";
import TransfersView from "./views/TransfersView.jsx";
import BackupsView from "./views/BackupsView.jsx";
import { C, font } from "../../lib/styles.js";

/**
 * Traffic Control — studio file orchestration. Woken from its "future"
 * badge on 2026-06-11 with exactly ONE working tab: Machines (the NYC
 * Bridge fleet registry — docs/ingest/12-nyc-bridge-platform.md). Studio
 * Map / Transfers / Backups stay visible placeholders until TC's brain
 * (moves, backups, purge guard) gets built.
 */
export default function TrafficApp({ activeTab, user }) {
  if (activeTab === "Machines" || !activeTab) {
    return <MachinesView user={user} />;
  }
  // SafeShare slice 5.2: where every file is (read-only).
  if (activeTab === "Transfers") return <TransfersView />;
  // SafeShare slice 5.3: what is not safe yet (red, amber, green per client file).
  if (activeTab === "Backups") return <BackupsView />;
  return (
    <div style={{ padding: 60, textAlign: "center", fontFamily: font }}>
      <div style={{ fontSize: 15, fontWeight: 500, color: C.text, marginBottom: 6 }}>{activeTab}</div>
      <div style={{ fontSize: 13, color: C.muted, fontWeight: 300 }}>
        Coming with Traffic Control&apos;s file orchestration build. Machines is live now.
      </div>
    </div>
  );
}
